module.exports = __webpack_public_path__ + "media/packs/users/img/footer/fa-comment-dots-solid-9d780a390330bb7be7d0344aa8f1517d.svg";